import { render } from "./DropOrdersComponent.vue?vue&type=template&id=44ad9afc&scoped=true"
import script from "./DropOrdersComponent.vue?vue&type=script&lang=js"
export * from "./DropOrdersComponent.vue?vue&type=script&lang=js"

import "./DropOrdersComponent.vue?vue&type=style&index=0&id=44ad9afc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ad9afc"]])

export default __exports__